var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query-block"},[_c('QueryGroup',{attrs:{"query":_vm.query,"delete_btn":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }